module.exports = __webpack_public_path__ + "img/carbonara_guanciale.ad5263cb.jpg";